export default "__VITE_ASSET__DHSFkjSp__"